import styled from "styled-components"

export const Container = styled.div`
    background-color: var(--medGrey);
    display: flex;
`

export const Wrapper = styled.div`
    flex: 1;
`

export const Main = styled.div`
    margin-top: 10px;
    flex: 4;
    color: var(--darkGrey);
    padding: 20px;
`

export const TitleWrapper = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
`

export const Title = styled.h1`
`

export const StyledButton = styled.button`
    margin-top: 10px;
    width: 80px;
    border: none;
    padding: 5px;
    background-color: var(--primary);
    color: var(--white);
    border-radius: 5px;
    font-size: var(--fontM);
    cursor: pointer;
`

export const Top = styled.div`
    display: flex;
`

export const Bottom = styled.div`
    margin: 20px;
    padding: 20px;
    border-radius: 10px;
    -webkit-box-shadow: 0px 0px 15px -10px rgba(0, 0, 0, 0.9);
    box-shadow: 0px 0px 15px -10px rgba(0, 0, 0, 0.9);
    background-color: var(--darkGrey);
    color: var(--lightGrey);
`

export const TopLeft = styled.div`
    flex: 1;
`

export const TopRight = styled.div`
    flex: 1;
    margin: 20px;
    padding: 20px;
    border-radius: 10px;
    -webkit-box-shadow: 0px 0px 15px -10px rgba(0, 0, 0, 0.9);
    box-shadow: 0px 0px 15px -10px rgba(0, 0, 0, 0.9);
    background-color: var(--darkGrey);
    color: var(--lightGrey);
`

export const InfoTop = styled.div`
    display: flex;
    align-items: center;
`

export const InfoBottom = styled.div`
    margin-top: 10px;
`

export const Image = styled.img`
    width: 60px;
    height: 60px;
    border-radius: 50%;
    object-fit: cover;
    margin-right: 20px;
    background-color: var(--medGrey);
`

export const Name = styled.span`
`

export const InfoItem = styled.div`
    display: flex;
`

export const ItemKey = styled.span`
    width: 100px;
    font-weight: 500;
`

export const ItemValue = styled.span`
    font-weight: 300;
`

export const CreateTitle = styled.h3`
`

export const StyledForm = styled.form`
    display: flex;
    margin-top: 20px;
`

export const CreateLeft = styled.div`
    margin-right: 50px;
`

export const CreateRight = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: space-between;
`

export const CreateItem = styled.div`
    display: flex;
    flex-direction: column;
    margin-top: 10px;
`

export const StyledLabel = styled.label`
    margin-bottom: 5px;
`

export const StyledInput = styled.input`
    background-color: var(--darkGrey);
    color: var(--lightGrey);
    border: none;
    border-bottom: 1px solid var(--primary);
    width: 250px;
    height: 30px;

    :focus{
        border-bottom: 1px solid var(--secondary);
        outline: none;
    }
`

export const StyledTextArea = styled.textarea`
    background-color: var(--darkGrey);
    color: var(--lightGrey);
    border: 1px solid var(--primary);
    width: 350px;
    height: 250px;

    :focus{
        border: 1px solid var(--secondary);
        outline: none;
    }
`

export const Upload = styled.div`
    margin-top: 10px;
    display: flex;
    align-items: center;
`

export const CreateImage = styled.img`
    width: 80px;
    height: 80px;
    border-radius: 10px;
    object-fit: cover;
    margin-right: 20px;
    background-color: var(--medGrey);
`

export const UploadIcon = styled.div`
    cursor: pointer;
    color: var(--secondary);
`

export const StyledSelect = styled.select`
    color-scheme: dark;
    height: ${({ multiple }) =>
        multiple ? "60px" : "30px"
    };
    border-radius: 5px;
    width: 250px;

    :focus{
        border: 1px solid var(--secondary);
        outline: none;
    }
`

export const StyledOption = styled.option`
`

export const NestedObjects = styled.div`
    display: flex;
    align-items: center;
    flex-wrap: wrap;
`

export const NestedObject = styled.div`
    min-width: ${({ type }) =>
        (type === "price") ? "30%" : "0"
    };
    margin: 20px 0px 20px 20px;
    padding: 20px;
    border-radius: 10px;
    -webkit-box-shadow: 0px 0px 15px -10px rgba(0, 0, 0, 0.9);
    box-shadow: 0px 0px 15px -10px rgba(0, 0, 0, 0.9);
    background-color: var(--darkGrey);
    color: var(--lightGrey);
`

export const AddVariation = styled.div`
    width: 80px;
    height: 80px;
    border-radius: 50%;
    background-color: var(--primary);
    color: var(--white);
    display: flex;
    align-items: center;
    justify-content: center;
    margin: 10px;
    transition: all 0.5s ease;
    cursor: pointer;

    &:hover{
        color: var(--secondary);
        transform: scale(1.1);
    }
`

export const ButtonContainer = styled.div`
    width: 100%;
    display: flex;
    justify-content: center;
`

export const ButtonWrapper = styled.div`
    margin: 20px;
    padding: 20px;
    border-radius: 10px;
    -webkit-box-shadow: 0px 0px 15px -10px rgba(0, 0, 0, 0.9);
    box-shadow: 0px 0px 15px -10px rgba(0, 0, 0, 0.9);
    background-color: var(--darkGrey);
    color: var(--lightGrey);
    width: 300px;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
`

export const Message = styled.div`
    margin-top: 20px;
    color: var(--secondary);
`